'use strict';

angular.module('TurneroApp').service('errorsService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/General/:id', { id: '@id' }, {
        Log_Error_Get: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/General/Errores_Get'
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/layout/errores/errorsService.js